import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mt-12" }
const _hoisted_2 = { class: "c-magic-line c-magic-line--underline whitespace-nowrap text-dusty-grey" }
const _hoisted_3 = { class: "mb-20" }
const _hoisted_4 = { class: "flex flex-nowrap" }
const _hoisted_5 = { class: "flex-1 mr-10" }
const _hoisted_6 = {
  key: 2,
  class: "mt-x3 pb-x3"
}

import { computed, ref } from 'vue';
import { Form } from 'vee-validate';
import BaseDialog from '@/shared/dialog/BaseDialog.vue';
import InputText from '@/shared/form/InputText.vue';
import ConfirmationButton from '@/shared/form/ConfirmationButton.vue';
import BlockLabelWithNamedArguments from '@/shared/BlockLabelWithNamedArguments.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import { ProductClientService, LabelWithNamedArguments } from '@/types/productServerApi';
import WebApiMessage from '@/core/http/WebApiMessage.vue';
import useBooleanToggle from '@/shared/useBooleanToggle';
import siteContextService from '@/b2c/shared/site-context.service';
import { useRouteQuery } from '@/core/browser/route-query.composable';
import { QueryKeys } from '@/shared/config/route-query.config';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductDetailDelivery',
  props: {
    id: {
        type: String,
        required: true,
    },
},
  setup(__props) {

const props = __props



const configurationIdQueryValue = useRouteQuery(QueryKeys.PDPConfigurationId);
const configurationId = computed<string | undefined>(() => configurationIdQueryValue.value || undefined);
const postalCodeValidationRegEx = computed<string>(() => siteContextService.country.postalCodeRegex);

const validation = computed(() => {
    return {
        postalCode: {
            required: true,
            max: 100,
            postalCode: postalCodeValidationRegEx.value,
        },
    };
});

const { isToggled, toggle } = useBooleanToggle();

const messageLabel = ref<LabelWithNamedArguments | undefined>(undefined);
const isClicked = ref(false);

const messageId = 'productDetailDeliveryMessage';

const labels = useBlockLabels();

const getDeliveryTime = async(postalCode: string) => {
    return configurationId.value === undefined
        ? await ProductClientService.getDeliveryTimeForProduct(props.id, postalCode, undefined, messageId)
        : await ProductClientService.getDeliveryTimeForConfiguration(configurationId.value, postalCode, undefined, messageId);
};

const submit = async({ postalCode }: any): Promise<void> => {
    isClicked.value = true;

    const deliveryTimeModel = await getDeliveryTime(postalCode);
    messageLabel.value = deliveryTimeModel.model?.label;
};


return (_ctx: any,_cache: any) => {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "flex gap-x1 items-center",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(toggle) && _unref(toggle)(...args)))
      }, [
        _createVNode(_component_c_icon, {
          name: "icon-delivery",
          class: "w-40 h-40 c-icon--no-fill inline-block"
        }),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(labels).calculateDeliveryTimeAction), 1)
      ])
    ]),
    _createVNode(BaseDialog, {
      "is-open": _unref(isToggled),
      class: "fixed inset-0 p-x3 mx-auto z-1 bg-white max-w-850 pt-60 flex flex-col sm:relative sm:inset-auto sm:h-auto sm:w-screen-75 md:w-screen-50 xl:w-screen-40 sm:max-h-screen-90",
      onClose: _unref(toggle)
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("h4", _hoisted_3, _toDisplayString(_unref(labels).calculateDeliveryTimeDialogTitle), 1),
          _createVNode(_unref(Form), {
            "validation-schema": _unref(validation),
            class: "-mb-20",
            onSubmit: submit
          }, {
            default: _withCtx(({ isSubmitting, errors }) => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(InputText, {
                    name: "postalCode",
                    class: "w-full xs:text-16 sm:text-inherit",
                    autocomplete: "off",
                    label: _unref(labels).calculateDeliveryTimeDialogEnterZipCode
                  }, null, 8, ["label"])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(ConfirmationButton, {
                    class: "c-button--outline min-w-100 -mt-4 sm:-mt-10 md:-mt-6 xl:-mt-4",
                    disabled: isSubmitting,
                    confirm: isSubmitting,
                    text: _unref(labels).calculateDeliveryTimeDialogAction,
                    "confirmation-text": '...'
                  }, null, 8, ["disabled", "confirm", "text", "confirmation-text"])
                ])
              ]),
              (!errors.postalCode)
                ? (_openBlock(), _createBlock(WebApiMessage, {
                    key: 0,
                    id: messageId,
                    "clear-timing": 5000,
                    class: "absolute -mt-39"
                  }))
                : _createCommentVNode("", true),
              (messageLabel.value && !isSubmitting)
                ? (_openBlock(), _createBlock(BlockLabelWithNamedArguments, {
                    key: 1,
                    label: messageLabel.value,
                    class: "font-bold"
                  }, null, 8, ["label"]))
                : _createCommentVNode("", true),
              (isClicked.value && !isSubmitting)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(labels).calculateDeliveryTimeDescription), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["validation-schema"])
        ])
      ]),
      _: 1
    }, 8, ["is-open", "onClose"])
  ], 64))
}
}

})